/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Import_DashboardInputs */

const en_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Description Import Dashboard`)
};

const fr_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du plan Importer le tableau de bord`)
};

const de_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot-Beschreibung Import-Dashboard`)
};

const it_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione dello scatto Importa dashboard`)
};

const ru_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель управления импортом описания кадра`)
};

const es_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de importación de descripción de tomas`)
};

const zh_cn2_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述导入仪表板`)
};

const ja_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの説明 ダッシュボードのインポート`)
};

const hi_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण आयात डैशबोर्ड`)
};

const pt_pt2_scene_description_import_dashboard = /** @type {(inputs: Scene_Description_Import_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição da cena Importar painel de controle`)
};

/**
* | output |
* | --- |
* | "Shot Description Import Dashboard" |
*
* @param {Scene_Description_Import_DashboardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_dashboard = /** @type {((inputs?: Scene_Description_Import_DashboardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_DashboardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_import_dashboard(inputs)
	if (locale === "de") return de_scene_description_import_dashboard(inputs)
	if (locale === "it") return it_scene_description_import_dashboard(inputs)
	if (locale === "ru") return ru_scene_description_import_dashboard(inputs)
	if (locale === "es") return es_scene_description_import_dashboard(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_import_dashboard(inputs)
	if (locale === "ja") return ja_scene_description_import_dashboard(inputs)
	if (locale === "hi") return hi_scene_description_import_dashboard(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_import_dashboard(inputs)
	return en_scene_description_import_dashboard(inputs)
});